import React, { ReactElement, ReactNode, useState, useImperativeHandle, forwardRef } from 'react';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import './Modal61.scss';

interface Modal61Props {
	title: string;
	body: ReactNode;
	primaryButtonText?: string;
	showSecondaryButton?: boolean;
	secondaryButtonText?: string;
	customFooter?: ReactNode;
	onShow?: any;
	onPrimaryClick?: any;
	onSecondaryClick?: any;
	onCloseClick?: any;
	isLoading?: boolean;
	isCentered?: boolean;
	size?: 'sm' | 'md' | 'lg' | 'xl';
	customClassName?: string;
}

const Modal61 = forwardRef(
	(
		{
			title,
			body,
			primaryButtonText,
			showSecondaryButton = false,
			secondaryButtonText,
			customFooter,
			onShow,
			onPrimaryClick,
			onSecondaryClick,
			onCloseClick,
			isLoading = false,
			isCentered = false,
			size = 'lg',
			customClassName = '',
		}: Modal61Props,
		ref
	): ReactElement => {
		const [show, setShow] = useState(false);

		useImperativeHandle(ref, () => ({
			show() {
				handleShow();
				onShow?.();
			},
			hide() {
				handleClose();
			},
		}));

		const handleClose = () => setShow(false);
		const handleShow = () => setShow(true);

		const handlePrimaryClick = async () => {
			if (onPrimaryClick) onPrimaryClick();
			else handleClose();
		};

		const handleSecondaryClick = () => {
			onSecondaryClick?.();
			handleClose();
		};

		const handleCloseClick = () => {
			onCloseClick?.();

			handleClose();
		};

		const dialogClassName = size === 'md' ? 'modal-61-dialog-med' : 'modal-61-dialog';
		const modalSize = size === 'md' ? undefined : size;

		return (
			<Modal size={modalSize} show={show} onHide={handleCloseClick} centered={isCentered} dialogClassName={`${dialogClassName} ${customClassName}`}>
				<LoadingIndicator isLoading={isLoading}>
					<Modal.Header closeButton>
						<Modal.Title>{title}</Modal.Title>
					</Modal.Header>
					<Modal.Body>{body}</Modal.Body>

					<Modal.Footer>
						{customFooter || (
							<>
								<Button variant='primary' onClick={handlePrimaryClick}>
									{primaryButtonText ? primaryButtonText : 'Ok'}
								</Button>
								{showSecondaryButton && (
									<Button variant='secondary' onClick={handleSecondaryClick}>
										{secondaryButtonText ? secondaryButtonText : 'Cancel'}
									</Button>
								)}
							</>
						)}
					</Modal.Footer>
				</LoadingIndicator>
			</Modal>
		);
	}
);

Modal61.displayName = 'Modal61';
export default Modal61;
